import { MDSDropdown } from '@marqvision/mds-v2';
import { useWebsiteContentCommentsQuery } from '~/apis/websiteContent';
import { DropDown } from '~/components/Filters/@types';
import { useLogger } from '~/hooks';
import { MarqCommonEnumsCommentCommentUserTypeEnum } from '~/swagger/data-contracts';
import { useRequest } from '~/pages/WebsiteContent/_impersonation/List/@hooks/useRequest';
import { parseDropDown, parseValueToValueArray } from '~/utils';
import { useTab } from '~/pages/WebsiteContent/_impersonation/@hooks/useTab';
import { ResponsiveProps } from '../Responsive/@types';

export const WebsiteContentCommentFilter = ({ size = 'medium' }: ResponsiveProps) => {
  const { request, onFilterChange } = useRequest();
  const { amplitudeLogging } = useLogger();
  const { currentTabGroup } = useTab();

  const commentUserTypeFilter = parseValueToValueArray(request.comment_user_type_filter);
  const selected =
    commentUserTypeFilter?.length === 2
      ? MarqCommonEnumsCommentCommentUserTypeEnum.All
      : commentUserTypeFilter?.[0] || null;

  const commentQuery = useWebsiteContentCommentsQuery<DropDown<MarqCommonEnumsCommentCommentUserTypeEnum>>(request, {
    select: parseDropDown,
  });

  const handleSelect = (value: MarqCommonEnumsCommentCommentUserTypeEnum | null) => {
    if (value) {
      amplitudeLogging('applied filter', {
        Type: 'comments',
        Channel: 'website content',
        Page: currentTabGroup.replace(/-/g, ' '),
      });

      if (value === MarqCommonEnumsCommentCommentUserTypeEnum.All) {
        onFilterChange('comment_user_type_filter', [
          MarqCommonEnumsCommentCommentUserTypeEnum.Client,
          MarqCommonEnumsCommentCommentUserTypeEnum.Admin,
        ]);
      } else if (value === MarqCommonEnumsCommentCommentUserTypeEnum.Admin) {
        onFilterChange('comment_user_type_filter', [value]);
      } else {
        onFilterChange('comment_user_type_filter', []);
      }
    } else {
      onFilterChange('comment_user_type_filter', []);
    }
  };

  const list = commentQuery.data?.list || [];
  const isDisabled = list.length === 0;
  const isFetching = commentQuery.isFetching;

  return (
    <MDSDropdown
      label="Comments"
      value={selected}
      list={list}
      isDisabled={isDisabled}
      isLoading={isFetching}
      onChange={(value: MarqCommonEnumsCommentCommentUserTypeEnum | null) => handleSelect(value)}
      modules={[
        'hide-select-all',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
